import { useCallback } from "react";

import { type USER_PERMISSION } from "@/constants/userPermission";
import { useAppSelector } from "@/redux/hook";
import { userState } from "@/redux/store";

export const useHasPermissions = (): ((permissions: USER_PERMISSION[]) => boolean) => {
  const { scope } = useAppSelector(userState);

  return useCallback(
    (permissions: USER_PERMISSION[]) => {
      return permissions.every((permission) => scope?.split(" ")?.includes(permission));
    },
    [scope]
  );
};
